import React from 'react';
import { useQuery } from 'react-query';
import AdvertisementCard from './AdvertisementCard';

const Advertisement = () => {
    const { data: advertisments = [] } = useQuery({
        queryKey: ["advertisment"],
        queryFn: () => fetch("https://car-server-12-rdm-jony.vercel.app/advertisment")
            .then(res => res.json())
    })
    return (
        advertisments.length > 0 && <div>
            <h3 className='text-2xl font-semibold text-center text-secondary'>Advertised items :{advertisments.length}</h3>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
                {
                    advertisments?.map(advertised => <AdvertisementCard key={advertised._id} advertised={advertised} ></AdvertisementCard>)
                }
            </div>
        </div>
    );
};

export default Advertisement;